import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { MonthYear } from "@common/types";
import { ICommandBase } from '@Quest/cqrs';
import { SaveViewScheduledProjectsPageCommandV1 } from "@Quest/Portfolios/Domain/commands-core";
import PortfoliosCommands from "@Quest/Portfolios/Domain/commands-vue-component";
import PortfoliosQueries from "@Quest/Portfolios/Domain/queries-vue-component";
import { ScheduledProjectsPageReadModel } from '@Quest/Portfolios/Domain/readmodels';
import { ProjectInProgressLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectInProgressLifecycleSetter";
import ProjectInProgressLifecycleSetter from '@Quest/Projects/Components/ProjectInProgressLifecycleSetter.vue';
import { ProjectProposalLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectProposalLifecycleSetter";
import ProjectProposalLifecycleSetter from '@Quest/Projects/Components/ProjectProposalLifecycleSetter.vue';
import { ProjectQualifiedLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectQualifiedLifecycleSetter";
import ProjectQualifiedLifecycleSetter from '@Quest/Projects/Components/ProjectQualifiedLifecycleSetter.vue';
import { ProjectRejectedLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectRejectedLifecycleSetter";
import ProjectRejectedLifecycleSetter from '@Quest/Projects/Components/ProjectRejectedLifecycleSetter.vue';
import { ProjectScheduledLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectScheduledLifecycleSetter";
import ProjectScheduledLifecycleSetter from '@Quest/Projects/Components/ProjectScheduledLifecycleSetter.vue';
import { ProjectsGridViewModel } from "@Quest/Projects/Components/ProjectsGrid";
import ProjectsGrid from "@Quest/Projects/Components/ProjectsGrid.vue";
import { SetLifecycleInProgressCommandV1, SetLifecycleProposalCommandV1, SetLifecycleQualifiedCommandV1, SetLifecycleRejectedCommandV1, SetLifecycleScheduledCommandV1 } from "@Quest/Projects/Domain/commands-core";
import ProjectsCommands from "@Quest/Projects/Domain/commands-vue-component";
import ProjectsQueries from '@Quest/Projects/Domain/queries-vue-component';
import { GridProjectReadModel } from '@Quest/Projects/Domain/readmodels';
import Vue from "vue";
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        PortfolioNavigation, ProjectsGrid,
        ProjectProposalLifecycleSetter, ProjectQualifiedLifecycleSetter, ProjectRejectedLifecycleSetter,
        ProjectScheduledLifecycleSetter, ProjectInProgressLifecycleSetter
    }
})
export default class ScheduledProjectsPage extends mixins(PortfoliosQueries, PortfoliosCommands, ProjectsCommands, ProjectsQueries)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId() { return Number.parseInt(this.$route.params.tchProjectId); }

    rm: ScheduledProjectsPageReadModel | null = null;
    get projects(): GridProjectReadModel[] { return this.rm?.Projects ?? []; }
    get portfolioId() { return this.rm.PortfolioId; }
    get portfolioName(): string | null { return this.rm?.PortfolioName; }

    grid: ProjectsGridViewModel = new ProjectsGridViewModel();

    projectQualifiedLifecycleSetter: ProjectQualifiedLifecycleSetterViewModel = new ProjectQualifiedLifecycleSetterViewModel();
    projectRejectedLifecycleSetter: ProjectRejectedLifecycleSetterViewModel = new ProjectRejectedLifecycleSetterViewModel();
    projectProposalLifecycleSetter: ProjectProposalLifecycleSetterViewModel = new ProjectProposalLifecycleSetterViewModel();
    projectScheduledLifecycleSetter: ProjectScheduledLifecycleSetterViewModel = new ProjectScheduledLifecycleSetterViewModel();
    projectInProgressLifecycleSetter: ProjectInProgressLifecycleSetterViewModel = new ProjectInProgressLifecycleSetterViewModel();


    handleShowGridColumnsEditor()
    {
        this.grid.showGridColumnsEditor();
    }

    handleSaveViewSettings()
    {
        const grid = this.grid.getJson();
        this.invokeSaveViewScheduledProjectsPageCommandV1(this.workspaceId, this.portfolioId, grid)
    }

    handleClearGridFilters()
    {
        this.grid.clearFilters();
    }

    handleExportGrid()
    {
        this.grid.exportGrid();
    }



    handleProposed(projectId: string)
    {
        this.invokeSetLifecycleProposalCommandV1(this.workspaceId, this.portfolioId, projectId);
    }

    handleQualified(projectId: string)
    {
        this.invokeSetLifecycleQualifiedCommandV1(this.workspaceId, this.portfolioId, projectId);
    }

    handleRejected(projectId: string)
    {
        this.invokeSetLifecycleRejectedCommandV1(this.workspaceId, this.portfolioId, projectId);
    }

    handleScheduled(projectId: string, startDate: MonthYear)
    {
        this.invokeSetLifecycleScheduledCommandV1(this.workspaceId, this.portfolioId, projectId, startDate);
    }

    handleStarted(projectId: string, startDate: MonthYear)
    {
        this.invokeSetLifecycleInProgressCommandV1(this.workspaceId, this.portfolioId, projectId, startDate);
    }


    mounted()
    {
        document.title = "Portfolio Scheduled | TransparentChoice";
        this.runScheduledProjectsPageQueryV1(this.workspaceId, this.tchProjectId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "ScheduledProjectsPageReadModel")
        {
            this.rm = model as ScheduledProjectsPageReadModel;

            Vue.nextTick(() =>
            {
                this.grid.renderGrid(this.rm.Grid.IdField, this.rm.Grid.Fields, this.rm.Grid.DefaultFieldIds, this.rm.Grid.Options);
                this.grid.setProjects(this.rm.Projects.map(p => p.Properties));
            })
        }
        else if (modelName === "GridProjectReadModel")
        {
            const rm = model as GridProjectReadModel;

            this.rm.Projects = this.rm.Projects.filter(p => p.Id !== rm.Id);
            this.rm.Projects.push(rm);

            this.grid.update(rm.Properties);
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (SaveViewScheduledProjectsPageCommandV1.matchType(cmd))
        {
            alert("Saved");
        }
        else if (SetLifecycleProposalCommandV1.matchType(cmd))
        {
            const projectId = correlationId;

            this.rm.Projects = this.rm.Projects.filter(a => a.Id !== projectId);
            this.grid.removeRowById(projectId);

            this.projectProposalLifecycleSetter.close();
        }
        else if (SetLifecycleQualifiedCommandV1.matchType(cmd))
        {
            const projectId = correlationId;

            this.rm.Projects = this.rm.Projects.filter(a => a.Id !== projectId);
            this.grid.removeRowById(projectId);

            this.projectQualifiedLifecycleSetter.close();
        }
        else if (SetLifecycleRejectedCommandV1.matchType(cmd))
        {
            const projectId = correlationId;

            this.rm.Projects = this.rm.Projects.filter(a => a.Id !== projectId);
            this.grid.removeRowById(projectId);

            this.projectRejectedLifecycleSetter.close();
        }
        else if (SetLifecycleScheduledCommandV1.matchType(cmd))
        {
            const projectId = correlationId;
            this.runGridProjectByIdQueryV1(this.workspaceId, this.portfolioId, projectId);
            
            this.projectScheduledLifecycleSetter.close();
        }
        else if (SetLifecycleInProgressCommandV1.matchType(cmd))
        {
            const projectId = correlationId;

            this.rm.Projects = this.rm.Projects.filter(a => a.Id !== projectId);
            this.grid.removeRowById(projectId);

            this.projectInProgressLifecycleSetter.close();
        }
    }
}